import React, { useEffect } from 'react';
import { Route, Routes } from 'react-router-dom';
import AppRoutes from './AppRoutes';
import Layout from './components/Layout';
import './custom.css';
import { LicenseInfo } from '@mui/x-data-grid-pro';
import LocaleSync from './i18n/LocaleSync';
import { SnackbarProvider } from './components/Common/SnackbarProvider';

LicenseInfo.setLicenseKey('ebf6ec2cccc013edb6e074b7c5b16361Tz0xMTA2OTYsRT0xNzc1MTc0Mzk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1RMy0yMDI0LEtWPTI=');

function AppShell() {
    return (
        <Layout>
            <Routes>
                {AppRoutes.map((route, index) => {
                    const { element, ...rest } = route;
                    return <Route key={index} {...rest} element={element}/>;
                })}
            </Routes>
        </Layout>
    );
}

const App = () => {
    useEffect(() => {
        // Order matters: Bootstrap's bundled Util touches $.fn as soon as it executes, and its
        // dropdowns need Popper. Injected scripts default to async, which lets them race and
        // leaves Bootstrap reading `fn` off an undefined jQuery; async = false makes the browser
        // run them in insertion order instead. The empty dependency array matters just as much --
        // without it this effect re-ran on every render and appended three more tags each time.
        const sources = [
            'https://cdnjs.cloudflare.com/ajax/libs/jquery/3.3.1/jquery.min.js',
            'https://cdnjs.cloudflare.com/ajax/libs/popper.js/1.12.9/umd/popper.min.js',
            'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/js/bootstrap.min.js',
        ];

        const scripts = sources.map((src) => {
            const script = document.createElement('script');
            script.src = src;
            script.async = false;
            document.body.appendChild(script);
            return script;
        });

        return () => scripts.forEach((script) => script.remove());
    }, []);

    return (
        <LocaleSync>
            <SnackbarProvider>
                <AppShell />
            </SnackbarProvider>
        </LocaleSync>
    );
};

export default App;
